<template>
  <v-container class="overview-page">
    <v-row class="ma-0">
      <v-col cols="12">
        <h2 class="primary--text font-weight-bold pt-5 pl-2">
          <v-icon color="primary" large left>line_weight</v-icon>
          {{ $t('common:qr-code_plural') }}
        </h2>

        <DataTable
            :enabledSearch="true"
            :addBtn="true"
            :addBtnRoute="`/${$store.state.manager.bookModuleUrl}/admin/qrcode/import`"
            :addBtnText="$t('book/admin:qrcode.overview.add-btn')"
            :headers="headers"
            :data="table.data"
            icon="create"
            @clickedButton1="editQRCode"
            sortBy="name"
            @cacheCommit="$store.commit('book/admin/storeQRCodeOverviewSearch', $event)"
            :cachedSearch="$store.state.book.admin.qrCodeOverviewSearch"
            @currentItems="updateQRCodes"
        />

      </v-col>
    </v-row>

    <v-card class="ma-4">
      <v-card-actions>
        <v-btn
            outlined
            color="primary"
            @click="print"
            :disabled="!table.filteredData || table.filteredData.length == 0">
          <v-icon left>print</v-icon>
          <span class="d-none d-sm-block">{{ $t('book/admin:qrcode.overview.print') }}</span>
        </v-btn>
        <QRCodePrint ref="printPage"/>
      </v-card-actions>
    </v-card>

  </v-container>
</template>

<script>
import DataTable from "@/modules/core/components/DataTable/DataTable";
import QRCodeService from "@/modules/book/services/qrcode-service";
import QRCodePrint from "@/modules/book/views/admin/qrcode/QRCodePrint";
import QRCode from "@/modules/book/data/qrcode";
import DataUtils from "@/modules/core/services/data-utils";
import Utils from "@/modules/core/services/utils";

export default {
  name: "QRCodeOverview",
  components: {
    DataTable,
    QRCodePrint
  },
  data() {
    return {
      table: {
        data: [],
        filteredData: []
      },
      tableUpdateTimer: null
    }
  },
  methods: {
    editQRCode(item) {
      this.$router.push(`/${this.$store.state.manager.bookModuleUrl}/admin/qrcode/${item.id}`);
    },
    print() {
      this.$refs.printPage.print();
    },
    updateQRCodes(items){
      this.table.filteredData = items;
      if(this.table.filteredData && this.table.filteredData.length > 0) {
        //using tiny timer so we don't generate tons of qr-codes while user is still inputing
        clearTimeout(this.tableUpdateTimer);
        this.tableUpdateTimer = setTimeout( () => {
          if(this.$refs && this.$refs.printPage) {
            this.$refs.printPage.updateData(this.table.filteredData);
          }
        },50);
      }
    }
  },
  computed: {
    headers() {
      return [
        {text: this.$t('common:name'), value: 'name'},
        {text: this.$t('common:customer'), value: 'customerName'},
        {text: this.$t('common:facility'), value: 'facilityName'},
        {text: '', value: 'controls', sortable: false},
      ]
    }
  },
  created() {
    QRCodeService.readAllFromAPI(
      (res) => {
        this.table.data = DataUtils.parseDataToObjectArray(res.data, QRCode);
      },
      (error) => {
        Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('common:qr-code_plural')}))
        this.$logger.error(error);
      }
    )
  }
}
</script>
